<template>
  <div class="contact-menu">
    <b-dropdown
      right
      no-caret
      toggle-class="settings__table-action"
      @click.stop.prevent>
      <template #button-content>
        <span
          class="menu-button flex center-all" />
      </template>
      <b-dropdown-item @click.stop.prevent="emitView">{{ viewActive ? 'Close' : 'View' }}</b-dropdown-item>
      <b-dropdown-item @click.stop.prevent="emitDelete">Delete</b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'ContactMenu',
  props: {
    contact: {
      type: Object,
      required: true,
    },
    tableIndex: {
      type: Number,
      required: false,
      default: -1,
    },
    viewActive: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    emitView() {
      this.$emit('view', this.contact, this.tableIndex);
    },
    emitDelete() {
      this.$emit('delete', this.contact);
    },
  },
};
</script>

<style lang="scss">
.contact-menu {
  margin-left: 12px;
  margin-right: 12px;

  .b-dropdown {
    ul.dropdown-menu {
      border-radius: 5px !important;
      padding: 0 !important;
      box-shadow: 0 2px 5px 0 rgba(13, 15, 22, 0.23) !important;
      border: none !important;
    }

    .settings__table-action {
      border: none !important;
      background: none !important;
      box-shadow: none !important;
      padding: 0 !important;

      &:active, &:focus, &:hover {
        border: none !important;
        background: none !important;
        outline: none !important;
        box-shadow: inherit !important;
      }
    }
  }
}
</style>
